export default __webpack_public_path__ + "img/sitio-web.7b33c49b.png";